import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { LoadingService } from '../shared/loading/loading.service';
import { AlertService } from '../shared/alerts/alerts.service';
import { EventsService } from '../shared/events/events.service';
import { LoginService } from './login.service';
import { ForgotPasswordService } from '../forgot.password/forgot.password.service';

@Component({
  selector: 'my-login',
  template: require('./login.component.html'),
  styles: [require('./login.component.scss'), require('../shared/styles/form.scss')]
})

export class LoginComponent implements OnInit {
  message: string;
  username: string;
  password: string;
  showMessage: boolean;
  showLoginForm: boolean;
  mfaEnabled: boolean;
  userId: string;
  constructor(
    private authService: AuthService, private router: Router, private route: ActivatedRoute,
    private loadingService: LoadingService, private loginService: LoginService, public eventsService: EventsService,
    private passwordService: ForgotPasswordService,
    public alertService: AlertService) {
    this.showMessage = false;
    this.showLoginForm = false;
    this.mfaEnabled = false;
    this.userId = '';
  }

  error(error: any): any {
    this.loadingService.hideLoading();
    let data;
    try {
      data = JSON.parse(error._body);
    } catch (e) { }

    let errMsg = (data && (data.message || data.error)) || 'Error Occurred.';
    this.alertService.createAlert(true, true, errMsg);
  }

  loginError(error: any) {
    this.password = '';
    let data;
    try {
      data = JSON.parse(error._body);
    } catch (e) { }

    let errMsg = (data && (data.message || data.error)) || 'Error Occurred.';
    this.alertService.createAlert(true, true, errMsg);
    this.loadingService.hideLoading();
  }

  successMfaStatus(data) {
    // Need to remove after getting default api
    window.localStorage.setItem('originLogin', JSON.stringify(true));

    if (data.isEnabled) {
      this.loadingService.hideLoading();
      this.mfaEnabled = true;
    } else {
      this.authService.navigate();
    }
  }

  onSubmit() {
    if ((!this.username || this.username.trim().length <= 0) || (!this.password || this.password.length <= 0) || this.mfaEnabled) {
      return;
    }
    this.loadingService.showLoading();
    this.showMessage = false;
    const params = {
      username: this.username.trim(),
      password: this.password
    };
    this.loginService.login(params).subscribe(sessionInfo => {
      this.userId = sessionInfo.userId;
      this.authService.setSession(sessionInfo);
      this.passwordService.getMfaStatus(this.userId, null, (data) => this.successMfaStatus(data), err => this.error(err));
    }, err => this.loginError(err));
  }

  loginForMfa() {
    let params = {};
    this.loginService.login(params).subscribe(sessionInfo => {
      this.authService.setSession(sessionInfo);
      this.authService.navigate();
    }, err => this.loginError(err));
  }

  logout() {
    this.authService.logout();
  }

  goToForgotPassword() {
    this.router.navigate(['/resetpassword'], { relativeTo: this.route });
  }

  setMessage(message) {
    this.showMessage = true;
    this.message = message;
  }

  ngOnInit() {
    this.loadingService.showLoading();

    this.authService.validateSession()
      .finally(() => this.loadingService.hideLoading())
      .subscribe(_ => {
        this.authService.gotoHome();
      }, _ => this.showLoginForm = true);

    this.eventsService.on('otpVerified', () => this.loginForMfa());
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/login/login.component.ts